<template>
<tr class="at-eg-row" :class="cls">
  <td class="at-eg-cell-b" v-for="(date, idx) in dates" :data-date="date" :class="'at-eg-cell-' + idx">
    <div class="at-eg-tgroup" :class="'at-eg-tall-' + tallSize" :style="childHeight > 0 ? 'min-height: '+childHeight+'px' : ''">
        <task-item v-for="(obj, idx1) in tasks" :task="task" :floor-index="0" v-if="task = obj[date]" ></task-item>
    </div>
  </td>
</tr>
</template>

<script>
import TaskItem from './TaskItem.vue'
export default {
  props: {
    childHeight: {
      default: 0,
    },
    user: {
      type: Object,
      required: true
    },
    dates: {
      type: Array,
      required: true
    },
    tasks: {
      type: Array,
      required: true
    },
    cls: {
      type: String
    }

  },
  computed: {
    tallSize () {
      return this.tasks.length
    }
  },
  mounted(){
    // this.$nextTick(()=>{
    //   console.log(this.tasks, "this.tasks")
    // })
  },
  components: {
    TaskItem
  }
}

</script>
